{
  "comment": "M7 S40 (spec §16.3 steps 1–5): the derelict survey card's text UI, the repair-port prompts and the restart's messages. Tokens in {braces}. Placeholder copy for the naming and voice pass (D-425). bands: SY-1's condition bands as the card's condition column shows them (salvage.json bands); kit components must be Serviceable or better. card.rushBonus and messages.rushCredit: M8 MC-h4b's Rush-pattern kit bonus (U14).",
  "card": {
    "title": "{designation}: First Rush {class}",
    "surveyTitle": "Derelict survey",
    "close": "Close",
    "restorable": "Restorable: the structure is sound enough to restart.",
    "notRestorable": "Not restorable.",
    "kitHeader": "Restart kit",
    "kitRow": "{label}: {delivered}/{need} ({band}; {inHold} in the hold)",
    "goodRow": "{label}: {delivered}/{need} t ({inHold} t in the hold)",
    "refit": "Refit after the restart: {template} at {costPct}% of the build cost.",
    "coolant": "Hazard: the reactor section's coolant anchor must be vented first.",
    "coolantVented": "Hazard: the coolant anchor is vented.",
    "wreckers": "Squatters: a Wrecker crew. Clear them or pay the fence fee ({fee} cr).",
    "family": "Occupied: the {family} family. Hail them; this is no fight.",
    "squatCleared": "Squatters: cleared.",
    "marker": "Holdfast generational claim: the {family} family.",
    "sealedCore": "A sealed core: needs power.",
    "bunker": "Bunker: {tonnes} t of First Rush-processed tetherstone.",
    "reboot": "Restart: hold the reactor {seconds} s against {waves} waves{guardians}.",
    "guardians": ", guardians nearby",
    "rushBonus": "Rush-pattern parts fit this station: each one in the kit saves {cells} t of fuel cells."
  },
  "classes": { "habRing": "habitat ring", "oreProcessor": "ore processor", "depot": "depot", "lab": "medical and survey lab" },
  "components": { "reactor": "Reactor", "radiator": "Radiator", "weapon": "Weapon", "shieldGen": "Shield generator", "thruster": "Thruster", "cargoPod": "Cargo pod", "dataCore": "Data core" },
  "bands": { "intact": "Intact", "serviceable": "Serviceable", "wrecked": "Wrecked", "required": "Serviceable or better" },
  "prompts": {
    "vent": "Vent the coolant anchor",
    "fence": "Pay the Wreckers off (the fence fee)",
    "hail": "Hail the family",
    "deliver": "Deliver the restart kit",
    "restart": "Begin the restart",
    "fight": "Call out the Wrecker squat"
  },
  "refusals": {
    "noRecord": "Survey the station first (a targeted scan with Scanner Mk II+).",
    "closed": "The restart is done.",
    "harrow": "Someone's already keeping this one alive.",
    "range": "Fly within {range} m of the repair port.",
    "speed": "Slow down at the repair port.",
    "hazard": "Vent the coolant anchor first.",
    "squatters": "Clear the squatters first.",
    "family": "The family is aboard. Hail them first.",
    "funds": "Not enough credits.",
    "nothing": "Nothing the kit still needs is in the hold (components must be Serviceable or better).",
    "incomplete": "The kit is not complete.",
    "retry": "The reactor scrammed. Retry after {days} online day(s).",
    "busy": "A restart is already running.",
    "scanner": "A survey needs Scanner Mk II or better."
  },
  "messages": {
    "vented": "Coolant anchor vented.",
    "ventedHot": "Coolant blowout: {damage} hull damage.",
    "paid": "The Wreckers take the fee and leave.",
    "fought": "The squat is cleared.",
    "family": "The family will talk. The choice comes at registration.",
    "familyHail": "The {family} family: \"Our grandmothers kept this ring warm. Say what you mean to do with it, and say it to us.\"",
    "delivered": "Delivered {what}.",
    "kitComplete": "The kit is complete: begin the restart.",
    "online": "{designation} is lit after fifty years. Register it.",
    "scram": "The reactor scrammed: the fuel cells are gone, the components stay. Retry after {days} online day(s).",
    "aborted": "Restart aborted; the kit is untouched.",
    "restartStarted": "Restart begun: hold the reactor for {time} against {waves} waves.",
    "squatOut": "The Wreckers come out shooting. Fight them off, or pay the fence fee ({fee} cr) at the port.",
    "squatLeft": "You broke off the fight; the Wreckers still hold the station.",
    "rushCredit": "The Rush-pattern parts fit the old sockets: {cells} t fewer fuel cells needed."
  }
}
